import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            专题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按主题分类浏览吃瓜内容，快速进入你感兴趣的专题合集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.slice(0, 4).map((item) => (
            <div
              key={item.id}
              className="group relative p-5 rounded-xl bg-background-100 border border-background-200 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2 py-0.5 rounded-full">
                {item.count} 条内容
              </span>
              <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexItems.slice(4).map((item) => (
            <div
              key={item.id}
              className="group relative p-5 rounded-xl bg-background-100 border border-background-200 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2 py-0.5 rounded-full">
                {item.count} 条内容
              </span>
              <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}